export default __webpack_public_path__ + "static/media/brainiac-icon.995142af.png";